import React, { useState } from 'react'
import Textarea from '../../../../../components/textarea';
import { notifyError } from '../../../../../components/loader';
import PropTypes from 'prop-types';

const DisableSchool = ({ onClose,schoolData ,DisableSchool}) => {
  const[reasonText,setReasonText] = useState("");
  const handleTextChange = (e)=>{
    setReasonText(e.target.value);
  }

  const handleSubmit = async(e)=>{
    e.preventDefault();
    if(!reasonText.trim()){
      return notifyError("Please enter a reason!");
    }
    await DisableSchool(schoolData.schoolId,reasonText);
     setReasonText("");
     onClose();
  }
  
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-[930px] xl:w-[1000px]  mt-20 flex flex-col">
        {/* Header */}
        <div className="px-8 py-4 border-b flex justify-between items-center bg-slate-50 rounded-t-2xl">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Disable school </h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-100 text-red-500 transition-all">✕</button>
        </div>
        <form action="" onSubmit={handleSubmit} className="p-8 overflow-y-auto">
            <div>
             
             <Textarea
              label="Enter Reason"
              placeholder={"Enter Reason for disable school"}
              value={reasonText}
              star="*"
              onChange={handleTextChange}
             />
            </div>

            <div className="flex justify-end gap-3 mt-8 pt-6 border-t">
            <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg font-bold bg-slate-200 text-slate-700 hover:bg-slate-300 transition-all">
              Cancel
            </button>
            <button type="submit" className="px-10 py-2 rounded-lg font-bold bg-blue-600 text-white hover:bg-blue-700 shadow-md transition-all">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}


DisableSchool.propTypes = {
  onClose: PropTypes.func.isRequired,
  DisableSchool: PropTypes.func.isRequired,
  schoolData: PropTypes.shape({
    schoolId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

export default DisableSchool
